var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M109.3 288H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H109.3l-32 32z",
  style: {
    opacity: 0.4
  }
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l160-160c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L77.3 256l137.3 137.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-160-160z",
  className: "arrow-left_svg__fa-primary"
})));
export default SvgArrowLeft;